import { FunctionComponent, ReactNode, useCallback, useMemo } from 'react'

import styled from 'styled-components'

import config from '@config'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import ChatbotAnswerFeedback from '@components/Chatbot/messages/AnswerFeedback'

import { AnswerType } from '../types'

const StyledAnswerFeedback = styled(ChatbotAnswerFeedback)`
  border-top: none;
  padding: 0;
  margin: 0;
`

const {
  usersnap: { aiSearchWidgetKey },
} = config

const AnswerFeedback: FunctionComponent<{
  answer: AnswerType
  children: ReactNode
}> = ({ answer, children }) => {
  const trackingOnClick = useCallback<
    TrackingFnType<{ rating: 'positive' | 'negative' }>
  >(
    ({ extraData: { rating } }) => ({
      event: 'et_result_feedback',
      button_label: rating,
      chatbot_entrypoint: answer.questionData?.isSuggestedQuestion
        ? 'suggested question'
        : 'custom question',
    }),
    [answer],
  )
  const handleTrackingOnClick = useTracking(trackingOnClick)

  const trackingFunction = useCallback(
    (rating: 'positive' | 'negative') => {
      handleTrackingOnClick({ rating })
    },
    [handleTrackingOnClick],
  )
  const customUserData = useMemo(
    () => ({
      text:
        answer.content?.map((contentItem) => contentItem.text).join(' ') ?? '',
    }),
    [answer],
  )

  return (
    <StyledAnswerFeedback
      usersnapKey={aiSearchWidgetKey}
      onboardingInProcess={false}
      trackingFunction={trackingFunction}
      customUsersnapData={customUserData}
      showFeedbackText={false}
      showButtonLabels={false}
    >
      {children}
    </StyledAnswerFeedback>
  )
}

export default AnswerFeedback
